<template>
  <span class="time-counter">
    <slot></slot>
    <span>{{ diff }}</span>
  </span>
</template>

<script>
  import moment from 'moment';

  import CalendarService from '@/services/calendarService';

  export default {
    name: 'HeaderMenuTimerCounter',
    props: {
      start: {
        required: true,
      },
    },
    mounted() {
      this.calculateTimeDiff();
      this.interval = setInterval(() => this.calculateTimeDiff(), 1000);
    },
    beforeDestroy() {
      clearInterval(this.interval);
    },
    data() {
      return {
        then: moment(this.start),
        diff: '00:00:00',
      };
    },
    methods: {
      addLeadingZero(number) {
        return (number < 10) ? `0${number}` : number;
      },

      calculateTimeDiff() {
        const diffParts = CalendarService.calculateTimeDiff(this.then);

        if (diffParts) {
          this.diff = diffParts.full;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .time-counter{
    // margin-bottom: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/HeaderMenuTimerCounter.vue